<template>
  <div class="modal-content" style="max-width: 95vw;">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ isEdit ? 'Izmeni' : 'Dodaj novi' }} AO+AN
      </h5>
    </div>
    <div class="modal-body">
      <div v-if="loading" class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else>
        <!-- Basic Info -->
        <div class="row mb-3">
          <div class="col-md-3">
            <label class="form-label">Važi od <span class="text-danger">*</span></label>
            <input
              type="date"
              class="form-control"
              v-model="formData.valid_from"
              :disabled="isEdit"
              required
            />
          </div>
          <div class="col-md-3">
            <label class="form-label">Aktivno</label>
            <div class="form-check mt-2">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="formData.active"
              />
            </div>
          </div>
        </div>

        <!-- Tabs for Passenger Counts -->
        <ul class="nav nav-tabs mb-3" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="one-plus-three-tab"
              data-bs-toggle="tab"
              data-bs-target="#one-plus-three"
              type="button"
              role="tab"
              aria-controls="one-plus-three"
              aria-selected="true"
            >
              1+3
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="one-plus-four-tab"
              data-bs-toggle="tab"
              data-bs-target="#one-plus-four"
              type="button"
              role="tab"
              aria-controls="one-plus-four"
              aria-selected="false"
            >
              1+4
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="one-plus-five-tab"
              data-bs-toggle="tab"
              data-bs-target="#one-plus-five"
              type="button"
              role="tab"
              aria-controls="one-plus-five"
              aria-selected="false"
            >
              1+5+
            </button>
          </li>
        </ul>

        <!-- Tab Content -->
        <div class="tab-content">
          <!-- 1+3 Tab -->
          <div
            class="tab-pane fade show active"
            id="one-plus-three"
            role="tabpanel"
            aria-labelledby="one-plus-three-tab"
          >
            <div class="table-responsive">
              <table class="table table-bordered table-sm" style="width: 100%; table-layout: fixed;">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20%;">Snaga motora kW</th>
                    <th style="width: 16%;">1. godina</th>
                    <th style="width: 16%;">2. godina</th>
                    <th style="width: 16%;">3. godina</th>
                    <th style="width: 16%;">4. godina</th>
                    <th style="width: 16%;">5. godina</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="range in powerRanges" :key="range">
                    <td><strong>{{ range }}</strong></td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+3'][range].godina_1"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+3'][range].godina_2"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+3'][range].godina_3"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+3'][range].godina_4"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+3'][range].godina_5"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 1+4 Tab -->
          <div
            class="tab-pane fade"
            id="one-plus-four"
            role="tabpanel"
            aria-labelledby="one-plus-four-tab"
          >
            <div class="table-responsive">
              <table class="table table-bordered table-sm" style="width: 100%; table-layout: fixed;">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20%;">Snaga motora kW</th>
                    <th style="width: 16%;">1. godina</th>
                    <th style="width: 16%;">2. godina</th>
                    <th style="width: 16%;">3. godina</th>
                    <th style="width: 16%;">4. godina</th>
                    <th style="width: 16%;">5. godina</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="range in powerRanges" :key="range">
                    <td><strong>{{ range }}</strong></td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+4'][range].godina_1"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+4'][range].godina_2"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+4'][range].godina_3"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+4'][range].godina_4"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+4'][range].godina_5"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 1+5+ Tab -->
          <div
            class="tab-pane fade"
            id="one-plus-five"
            role="tabpanel"
            aria-labelledby="one-plus-five-tab"
          >
            <div class="table-responsive">
              <table class="table table-bordered table-sm" style="width: 100%; table-layout: fixed;">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20%;">Snaga motora kW</th>
                    <th style="width: 16%;">1. godina</th>
                    <th style="width: 16%;">2. godina</th>
                    <th style="width: 16%;">3. godina</th>
                    <th style="width: 16%;">4. godina</th>
                    <th style="width: 16%;">5. godina</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="range in powerRanges" :key="range">
                    <td><strong>{{ range }}</strong></td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+5+'][range].godina_1"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+5+'][range].godina_2"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+5+'][range].godina_3"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+5+'][range].godina_4"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model.number="formData['1+5+'][range].godina_5"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="cancel">
        Odustani
      </button>
      <button type="button" class="btn btn-primary" @click="saveData">
        Sačuvaj
      </button>
    </div>
  </div>
</template>

<script>
import AoAnDataService from "../../services/ao-an.service";

export default {
  name: "ao-an-form",
  props: ["data"],
  data() {
    const emptyRange = () => ({ godina_1: null, godina_2: null, godina_3: null, godina_4: null, godina_5: null });
    
    return {
      loading: false,
      powerRanges: [
        "do 22",
        "22 - 33 kw",
        "33 - 44 kw",
        "44 - 55 kw",
        "55 - 66 kw",
        "66 - 84 kw",
        "84 - 110 kw",
        "preko 110kw",
      ],
      passengerTypes: ["1+3", "1+4", "1+5+"],
      formData: {
        valid_from: "",
        active: true,
        "1+3": {
          "do 22": emptyRange(),
          "22 - 33 kw": emptyRange(),
          "33 - 44 kw": emptyRange(),
          "44 - 55 kw": emptyRange(),
          "55 - 66 kw": emptyRange(),
          "66 - 84 kw": emptyRange(),
          "84 - 110 kw": emptyRange(),
          "preko 110kw": emptyRange(),
        },
        "1+4": {
          "do 22": emptyRange(),
          "22 - 33 kw": emptyRange(),
          "33 - 44 kw": emptyRange(),
          "44 - 55 kw": emptyRange(),
          "55 - 66 kw": emptyRange(),
          "66 - 84 kw": emptyRange(),
          "84 - 110 kw": emptyRange(),
          "preko 110kw": emptyRange(),
        },
        "1+5+": {
          "do 22": emptyRange(),
          "22 - 33 kw": emptyRange(),
          "33 - 44 kw": emptyRange(),
          "44 - 55 kw": emptyRange(),
          "55 - 66 kw": emptyRange(),
          "66 - 84 kw": emptyRange(),
          "84 - 110 kw": emptyRange(),
          "preko 110kw": emptyRange(),
        },
      },
    };
  },
  computed: {
    isEdit() {
      return this.data && this.data.valid_from;
    },
  },
  mounted() {
    if (this.isEdit) {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.formData.valid_from = this.data.valid_from;
      
      // Load data for all three passenger types
      try {
        const promises = this.passengerTypes.map(type => 
          AoAnDataService.getByValidFromAndType(this.data.valid_from, type)
            .then(response => ({ type, records: response.data }))
            .catch(() => ({ type, records: [] }))
        );
        
        const results = await Promise.all(promises);
        
        results.forEach(({ type, records }) => {
          records.forEach((record) => {
            if (this.formData[type] && this.formData[type][record.snaga_kw]) {
              this.formData[type][record.snaga_kw] = {
                godina_1: record.godina_1,
                godina_2: record.godina_2,
                godina_3: record.godina_3,
                godina_4: record.godina_4,
                godina_5: record.godina_5,
              };
            }
            this.formData.active = record.active;
          });
        });
        
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: "Error loading AO+AN data",
        });
        this.loading = false;
      }
    },
    async saveData() {
      if (!this.formData.valid_from) {
        this.$store.commit("app/showAlert", {
          type: "warning",
          message: "Molimo popunite obavezno polje (Važi od)",
        });
        return;
      }

      if (this.isEdit) {
        await this.update();
      } else {
        await this.create();
      }
    },
    cancel() {
      this.$store.commit("app/hideModal");
    },
    async update() {
      try {
        // Update all three passenger types
        const promises = this.passengerTypes.map(type => {
          const typeData = {};
          this.powerRanges.forEach(range => {
            typeData[range] = this.formData[type][range];
          });
          
          return AoAnDataService.update(
            this.formData.valid_from,
            type,
            { ...typeData, active: this.formData.active }
          );
        });
        
        await Promise.all(promises);
        
        this.$store.commit("app/showAlert", {
          type: "success",
          message: "AO+AN je promenjen!",
        });
        this.$store.commit("app/hideModal");
      } catch (e) {
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: e.response?.data?.message || e.message,
        });
      }
    },
    async create() {
      try {
        // Create all three passenger types
        const promises = this.passengerTypes.map(type => {
          const typeData = {};
          this.powerRanges.forEach(range => {
            typeData[range] = this.formData[type][range];
          });
          
          return AoAnDataService.create({
            valid_from: this.formData.valid_from,
            type: type,
            ...typeData,
            active: this.formData.active,
          });
        });
        
        await Promise.all(promises);
        
        this.$store.commit("app/showAlert", {
          type: "success",
          message: "AO+AN je kreiran!",
        });
        this.$store.commit("app/hideModal");
      } catch (e) {
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: e.response?.data?.message || e.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.table {
  font-size: 0.875rem;
  margin-bottom: 0;
}
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  padding: 0.5rem 0.25rem;
  white-space: nowrap;
}
.table td {
  vertical-align: middle;
  padding: 0.4rem 0.25rem;
}
.form-control-sm {
  font-size: 0.875rem;
  padding: 0.3rem 0.4rem;
  width: 100%;
}
.modal-body {
  padding: 1rem 1.5rem;
}
.table-responsive {
  overflow-x: auto;
  overflow-y: visible;
}
.nav-tabs {
  margin-bottom: 1rem;
}
.tab-content {
  padding: 0;
}
.row.mb-3 {
  margin-bottom: 1rem !important;
}
</style>
